// Copyright (c) 2018 Deere & Company

import actions from '../action-list';

export const updateIsActionButtonDisabled = isDisabled =>

    dispatch => {

        dispatch({
            isDisabled,
            type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_IS_ACTION_BUTTON_DISABLED
        });

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/is-action-button-disabled.js